module.exports = __webpack_public_path__ + "2c91330f7bb43029f66e9ee52184c66b.png";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/dtac.png
// module id = 447
// module chunks = 47